// =============================================
// NAV — Burger menu + mobile overlay
// =============================================

(function () {
  var burgerBtn   = document.getElementById('burger-btn');
  var menuOverlay = document.getElementById('menu-overlay');
  var menuClose   = document.getElementById('menu-close');

  if (!burgerBtn || !menuOverlay) return;

  function openMenu() {
    burgerBtn.classList.add('is-open');
    menuOverlay.classList.add('is-open');
    menuOverlay.setAttribute('aria-hidden', 'false');
    burgerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    burgerBtn.classList.remove('is-open');
    menuOverlay.classList.remove('is-open');
    menuOverlay.setAttribute('aria-hidden', 'true');
    burgerBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burgerBtn.addEventListener('click', function () {
    if (menuOverlay.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuOverlay.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Close when clicking outside inner
  menuOverlay.addEventListener('click', function (e) {
    if (e.target === menuOverlay) closeMenu();
  });

  // Overlay sub-menu toggle
  var triggers = document.querySelectorAll('.menu-overlay__trigger');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var parent = this.closest('.menu-overlay__item');
      if (parent) parent.classList.toggle('is-open');
    });
  });
})();
